/* ─────────────────────────────────────────────────────────
   Professional SVG icon set — stroke-based, currentColor
   All icons: 24×24 viewBox, strokeWidth 1.5
   ───────────────────────────────────────────────────────── */

const I = ({ d, cls = 'w-6 h-6', extra }) => (
  <svg viewBox="0 0 24 24" className={cls} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    {extra}
    <path d={d} />
  </svg>
);

export const IcoHeart = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
);

export const IcoUsers = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

export const IcoUser = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

export const IcoMapPin = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

export const IcoBook = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
  </svg>
);

export const IcoActivity = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
  </svg>
);

export const IcoDroplet = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>
  </svg>
);

export const IcoHome = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

export const IcoHandshake = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.5 14.5L4 9l2-2 3.5 3.5"/>
    <path d="M14.5 9.5L20 15l-2 2-3.5-3.5"/>
    <path d="M12 7l-1.5-1.5a2 2 0 0 0-3 0L6 7l3 3 3-3z"/>
    <path d="M12 17l1.5 1.5a2 2 0 0 0 3 0L18 17l-3-3-3 3z"/>
  </svg>
);

export const IcoGlobe = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

export const IcoMail = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

export const IcoPhone = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

export const IcoClock = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

export const IcoSun = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="1" x2="12" y2="3"/>
    <line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/>
    <line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);

export const IcoMoon = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

export const IcoMenu = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <line x1="3" y1="6" x2="21" y2="6"/>
    <line x1="3" y1="12" x2="21" y2="12"/>
    <line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

export const IcoClose = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

export const IcoChevronDown = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-4 h-4'} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

export const IcoArrow = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-4 h-4'} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

export const IcoCheck = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

export const IcoTarget = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </svg>
);

export const IcoEye = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

export const IcoShield = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

export const IcoStar = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

export const IcoLeaf = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 8C8 10 5.9 16.17 3.82 19.78A1 1 0 0 0 4.6 21h.6c2.14-.42 4.16-1.07 6.2-2.2C15 16.77 17 12.07 17 8z"/>
    <path d="M3 21c0-5 2-10 5-13"/>
  </svg>
);

export const IcoAward = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="7"/>
    <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
  </svg>
);

export const IcoBriefcase = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2"/>
    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
    <line x1="12" y1="12" x2="12" y2="12"/>
    <path d="M2 12h20"/>
  </svg>
);

export const IcoTrendingUp = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
    <polyline points="17 6 23 6 23 12"/>
  </svg>
);

export const IcoPlay = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-6 h-6'} fill="currentColor">
    <polygon points="5 3 19 12 5 21 5 3"/>
  </svg>
);

export const IcoSearch = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);

export const IcoExpand = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
  </svg>
);

export const IcoSend = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);

export const IcoWhatsApp = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export const IcoFacebook = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

export const IcoInstagram = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <rect x="2" y="2" width="20" height="20" rx="5"/>
    <circle cx="12" cy="12" r="4"/>
    <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none"/>
  </svg>
);

export const IcoLinkedIn = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

export const IcoYoutube = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

export const IcoImage = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-8 h-8'} fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <circle cx="8.5" cy="8.5" r="1.5"/>
    <polyline points="21 15 16 10 5 21"/>
  </svg>
);

export const IcoQuote = ({ cls }) => (
  <svg viewBox="0 0 32 32" className={cls || 'w-8 h-8'} fill="currentColor">
    <path d="M10 8C6.686 8 4 10.686 4 14v2c0 3.314 2.686 6 6 6h1l-1 4h3l2-4v-2c0 0 0 0 0 0h-1V14c0-1.105.895-2 2-2h-6zm14 0c-3.314 0-6 2.686-6 6v2c0 3.314 2.686 6 6 6h1l-1 4h3l2-4v-2h-1V14c0-1.105.895-2 2-2h-6z"/>
  </svg>
);

export const IcoInfo = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={cls || 'w-5 h-5'} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

export const IcoSpinner = ({ cls }) => (
  <svg viewBox="0 0 24 24" className={`animate-spin ${cls || 'w-5 h-5'}`} fill="none">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
  </svg>
);

/* Brand logo mark */
export const LogoMark = ({ cls = 'w-9 h-9' }) => (
  <svg viewBox="0 0 40 40" className={cls} fill="none">
    <circle cx="20" cy="20" r="19" stroke="#ea580c" strokeWidth="1.5" fill="rgba(234,88,12,0.08)"/>
    <circle cx="20" cy="20" r="12" fill="#ea580c"/>
    <path d="M13 20 Q20 11 27 20 Q20 29 13 20Z" fill="white"/>
  </svg>
);
